import {AfterContentInit, Component, ContentChildren, QueryList} from '@angular/core';
import {TabComponent} from './tab/tab.component';

@Component({
    selector: 'vui-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements AfterContentInit {
    @ContentChildren(TabComponent) public tabs: QueryList<TabComponent>;

    constructor() {
        this.tabs = new QueryList<TabComponent>();
    }

    ngAfterContentInit(): void {
        this.tabs.first.tabbed = true;
    }

    /**
     * Toggle between the active tab
     * @param tab
     */
    public toggle(tab: TabComponent): void {
        this.tabs.forEach((_tab) => {
            _tab.tabbed = false;
        });
        tab.tabbed = true;
    }
}
